
				var addMethods = require("../../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["getCompleteDataArrayInTimeRange","getAxisMinTimestamp","getSeriesFeaturesDataForEcharts","getSeriesGroupDataForEcharts","getDatasetFeaturesDataForEcharts","getSortedFeaturesValuesByProperty","getGroupedValuesByProperty","getGroupedValuesByTimeBucket","getGroupedValuesByPropertySplitByProperty","getGroupedValuesByTimeBucketSplitByProperty"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "4a77d7574d5fcd676d0e.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			